export default __webpack_public_path__ + "static/media/Junaidul-Kader-Tanzim-Frontend-Developer-Resume-2022.ddf81560.pdf";